var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 320.37 354.98",
    viewBox: "0 0 320.37 354.98",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m230.26 281.3h-140.14c-6.6 0-12-5.4-12-12l-17-107.63c0-6.6 5.4-12 12-12h174.14c6.6 0 12 5.4 12 12l-17 107.63c0 6.6-5.4 12-12 12z",
    fill: "#75c8ac"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.4,
    cy: 210.7,
    fill: "#1f352d",
    r: 8.86
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.84,
    cy: 210.7,
    fill: "#1f352d",
    r: 8.86
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m142.56 252.32c-.39 0-.78-.11-1.12-.35-.91-.62-1.15-1.87-.53-2.78 3.05-4.49 10.66-7.38 19.37-7.38 8.15 0 15.55 2.63 18.87 6.7.7.86.57 2.12-.29 2.81-.86.7-2.12.57-2.81-.29-2.54-3.13-8.88-5.23-15.76-5.23-7.2 0-13.81 2.32-16.07 5.63-.39.59-1.02.89-1.66.89z",
    fill: "#1f352d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m271.37 163.63h-222.93c-6.6 0-12-5.4-12-12v-15.19c0-6.6 5.4-11 12-11h222.93c6.6 0 12 4.4 12 11v15.19c0 6.6-5.4 12-12 12z",
    fill: "#75c8ac"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m97.12 269.3-13.52-85.58h172.17l3.17-20.09h-178.52-19l16.7 105.67c0 6.6 5.4 12 12 12h19c-6.6 0-12-5.4-12-12z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m283.2 232.23-1.51 1.51c-2.93 2.93-7.73 2.93-10.66 0l-83.55-83.55c-2.93-2.93-2.93-7.73 0-10.66l1.51-1.51c2.93-2.93 7.73-2.93 10.66 0l83.55 83.55c2.93 2.93 2.93 7.73 0 10.66z",
    fill: "#1f352d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.92 233.74-1.51-1.51c-2.93-2.93-2.93-7.73 0-10.66l83.55-83.55c2.93-2.93 7.73-2.93 10.66 0l1.51 1.51c2.93 2.93 2.93 7.73 0 10.66l-83.55 83.55c-2.94 2.93-7.73 2.93-10.66 0z",
    fill: "#1f352d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.19,
    cy: 339.02,
    fill: "#ededed",
    rx: 90.7,
    ry: 11.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m261.58 77.39c.02 5.13-4.17 9.27-9.35 9.23-4.94-.04-8.97-4.09-9.03-9.06-.06-5.16 4.09-9.38 9.2-9.36 5.03.02 9.16 4.16 9.18 9.19zm-9.16 2.88c1.8-.15 2.82-1.21 2.81-2.87-.01-1.69-1.14-2.73-2.83-2.88-1.51-.13-3.04 1.5-2.9 3.03.17 1.73 1.22 2.62 2.92 2.72z",
    fill: "#acf2e5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 108.39c.02 4.16-3.39 7.53-7.59 7.49-4.01-.03-7.28-3.32-7.33-7.36-.05-4.19 3.32-7.62 7.47-7.6 4.08.03 7.44 3.39 7.45 7.47zm-7.44 2.34c1.46-.12 2.29-.98 2.28-2.33-.01-1.37-.93-2.22-2.3-2.34-1.23-.11-2.47 1.22-2.35 2.46.14 1.41.99 2.13 2.37 2.21z",
    fill: "#acf2e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m123.67 36.65c-7.13 0-12.33-5.16-12.36-12.24-.03-7.06 5.27-12.63 12.09-12.71 6.93-.08 12.96 5.89 12.86 12.75-.11 6.89-5.58 12.2-12.59 12.2zm.25-8.53c2.13-.01 3.35-1.52 3.72-3.73.31-1.87-1.75-3.94-3.79-4.05-2-.11-3.92 1.71-4.01 3.8-.08 2.19 1.55 3.92 4.08 3.98z",
    fill: "#fddeff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m80.67 78.57c-1.83.06-3.46-1.45-3.56-3.29-.1-1.92 1.5-3.64 3.41-3.66 1.86-.02 3.38 1.49 3.42 3.4.05 1.87-1.44 3.49-3.27 3.55z",
    fill: "#acf2e5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m202.67 39.57c-1.83.06-3.46-1.45-3.56-3.29-.1-1.92 1.5-3.64 3.41-3.66 1.86-.02 3.38 1.49 3.42 3.4.05 1.87-1.44 3.49-3.27 3.55z",
    fill: "#acf2e5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m302.69 122.39c-.07 3.41-3.06 6.24-6.44 6.07-3.11-.16-5.86-3.15-5.82-6.35.04-3.15 2.94-6.03 6.09-6.03 3.37-.02 6.22 2.9 6.17 6.31z",
    fill: "#fddeff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m170.69 83.39c-.07 3.41-3.06 6.24-6.44 6.07-3.11-.16-5.86-3.15-5.82-6.35.04-3.15 2.94-6.03 6.09-6.03 3.37-.02 6.22 2.9 6.17 6.31z",
    fill: "#fddeff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m56.84 125.44h-8.4c-6.6 0-12 4.4-12 11v15.19c0 6.6 5.4 12 12 12h8.4c-10.42-19.09 0-38.19 0-38.19z",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m217.65 247.73c4.53 0 4.53-7.04 0-7.04-4.52.01-4.53 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.34 255.31c4.53 0 4.53-7.04 0-7.04-4.52.01-4.53 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.78 263.45c4.53 0 4.53-7.04 0-7.04-4.53.01-4.54 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.96 255.31c4.53 0 4.53-7.04 0-7.04-4.52.01-4.53 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.67 247.73c4.53 0 4.53-7.04 0-7.04-4.53.01-4.53 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.36 255.31c4.53 0 4.53-7.04 0-7.04-4.53.01-4.53 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.79 263.45c4.53 0 4.53-7.04 0-7.04-4.52.01-4.53 7.04 0 7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.98 255.31c4.53 0 4.53-7.04 0-7.04-4.53.01-4.53 7.04 0 7.04z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.b2d29c3e397e76909bc062458085cbe7.svg";
export { ForwardRef as ReactComponent };